import { createTheme } from '@mui/material/styles'
import palette from 'theme/palette'
import typography from 'theme/typography'
import components from 'theme/components'
import breakpoints from 'theme/breakpoint'
import componentHeight from 'theme/componentHeight'
import { fontLists } from 'theme/font'
/* eslint no-eval: 0 */

const theme = createTheme({
  palette,
  typography,
  components,
  componentHeight,
  breakpoints,
})

fontLists.forEach((item) =>
  eval(`theme.typography.${item.font} =  {
    fontSize: '${item.size}px',
    lineHeight: '${item.size * 1.5}px',
    fontWeight : ${item.fontWeight},
    [theme.breakpoints.up('lg')]: {
        fontSize: '${item.sizeLg}px',
        lineHeight: '${item.sizeLg * 1.5}px',
    },
}`)
)

export default theme
